import { FeatureProps } from "./feature";
import {
  DiDocker,
  DiGit,
  DiGithubBadge,
  DiMongodb,
  DiNodejs,
  DiPostgresql,
  DiReact,
  DiVisualstudio,
} from "react-icons/di";
import { FaGoogle } from "react-icons/fa";
import { AiFillRobot } from "react-icons/ai";
import { Icon } from "@chakra-ui/react";

export const FeaturesList: FeatureProps[] = [
  {
    title: "Nodejs",
    text: "JavaScript runtime built on Chrome's V8 JavaScript engine.",
    icon: <Icon as={DiNodejs} w={10} h={10} />,
  },
  {
    title: "AI Tools",
    text: "Anthropic (Cloude), OpenAi (ChatGPT), GCP (DocumentAI)",
    icon: <Icon as={AiFillRobot} w={10} h={10} />,
  },
  {
    title: "React/React Native",
    text: "Free and open-source front-end JavaScript library for building user interfaces based on UI components.",
    icon: <Icon as={DiReact} w={10} h={10} />,
  },
  {
    title: "Mongodb",
    text: "Source-available cross-platform document-oriented database program. Classified as a NoSQL database program.",
    icon: <Icon as={DiMongodb} w={10} h={10} />,
  },
  {
    title: "Docker",
    text: "Developers Love Docker. Businesses Trust It.",
    icon: <Icon as={DiDocker} w={10} h={10} />,
  },
  {
    title: "GCP",
    text: "Google Cloud Provider",
    icon: <Icon as={FaGoogle} w={10} h={10} />,
  },
  {
    title: "Git",
    text: "Git",
    icon: <Icon as={DiGit} w={10} h={10} />,
  },
  {
    title: "Github",
    text: "Github",
    icon: <Icon as={DiGithubBadge} w={10} h={10} />,
  },
  {
    title: "PostgreSQL",
    text: "Postgres",
    icon: <Icon as={DiPostgresql} w={10} h={10} />,
  },
  {
    title: "VsCode",
    text: "Source-code editor made by Microsoft.",
    icon: <Icon as={DiVisualstudio} w={10} h={10} />,
  },
];
